import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAsset } from "../../actions/assetAction";
import { getAssetAttributes } from "../../actions/assetAttributesActions";
import { getAssetchart, getAttributescurrency, getAttributelegalStructure, getSecurityType, getAssetInvestmentType, getAssetFilingStatus, getInvestorFrequency, getAssetReportingFrequency, getExposuresReportingFrequency, getInvestInOtherFunds, getEstimateFrequency } from "../../actions/assetAttributesActions";
import { useNavigate } from "react-router";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { useParams, useLocation } from "react-router-dom";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { SBADropDown } from "../../UiComponents/SBADropDown";
import { UrlPath } from "../../../config/routeConfig";
import moment from "moment";
import { TopBar } from "../../shared/topBar/TopBar";
import { ToastContainer } from "react-toastify";
import { InsertorUpdateAttributes, InsertorUpdatePEAttributes, InsertorUpdateHFAttributes, InsertorUpdateMSAttributes, getCountries, getEnumerations } from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";
import { getAssestListddlAction } from "../../actions/assetsddlAction";
import { SBDatePicker } from '../../UiComponents/SBDatePicker';
import { SBNotify } from "../../utils/sbNotify";

const blankAttribute = {
  "AssetId": 0,
  "AssetAttributeId": 0,
  "AssetAttributeHFId": 0,
  "AssetAttributePEId": 0,
  "AssetAttributeMSId": 0,
  "AssetFamilyId": 0,
  "AssetFamily": "",
  "ChartOfAccountId": 0,
  "ChartOfAccount": "",
  "OperatingCurrencyId": 0,
  "OperatingCurrency": "",
  "LegalStructureId": 0,
  "LegalStructure": "",
  "DomicileCountryId": 0,
  "DomicileCountry": "",
  "QuarterlyLetter": false,
  "AssetSecurityTypeId": 0,
  "AssetSecurityType": "",
  "AuditCompletionDate": null,
  "InvestmentTypeId": 0,
  "InvestmentType": "",
  "InvestmentPack": false,
  "AssetFactSheet": false,
  "AllowsSidePocket": false,
  "InvestsInOtherFundsId": 0,
  "InvestsInOtherFunds": "",
  "ExposureReportFrequencyId": 0,
  "ExposureReportFrequency": "",
  "PersonalCapital": "0",
  "AccceptsManagedAccounts": false,
  "InvestsInManagedAccount": false,
  "TradingCity": "",
  "ProhibitsUSInvestors": false,
  "FilingStatusId": 0,
  "FilingStatus": "",
  "KeyMan": false,
  "InvestorLetterFrequencyId": 0,
  "InvestorLetterFrequency": "",
  "PerfEstimateFrequencyId": 0,
  "PerfEstimateFrequency": "",
  "BloombergId": "",
  "ReportingFrequencyId": 0,
  "ReportingFrequency": "",
  "FiscalYear": null,
  "TaxId": "",
  "CIMAId": "",
  "FormDNumber": "",
  "VintageYear": null,
  "TargetFundRaise": 0,
  "EstimatedFirstCloseDate": null,
  "EstimatedFirstCloseAmount": 0,
  "EstimatedSecondCloseDate": null,
  "EstimatedSecondCloseAmount": 0,
  "OfferCoInvestment": false,
  "SingleDealFund": false,
  "ContinuationFund": false,
  "IssuerId": 0,
  "Issuer": "",
  "SharesOutstanding": 0,
  "CUSIP": "",
  "ISIN": "",
  "ManagementFee": 0,
  "FundFeeExpenses": 0,
  "OtherExpenses": 0,
  "ExpenseRatio": 0,
  "DistributionFrequencyId": 0,
  "DistributionFrequency": "",
  "IsMarketable": false,
  "ModifiedBy": 0,
  "IsClientSpecific":false
};
export const AttributesEdit = () => {

  const params = useParams();
  const dispatch = useDispatch();
  const history = useNavigate();

  const Gstate = useSelector((state) => state) || {};
  const isEditable = useSelector(state => state.authorizationData.isEditable);
  const Attributes = Gstate.attributesDetails.attributesDetails || {};
  const isLoading = Gstate.attributesDetails.isAssetAttributeLoading;
  const currentAsset = Gstate.asset.asset || {};

  const AssetListDDL = Gstate.assetDDL.assetList || [];
  const Chartofaccounts = Gstate.chartofaccounts.chartofaccounts || [];
  const AttributesCurrency = Gstate.attributescurrency.attributescurrency || [];
  const LegalStructureDS = Gstate.attributelegalstructure.attributelegalstructure || [];
  const SecurityType = Gstate.securityType.securityType || [];
  const FilingStatus = Gstate.filingStatus.filingStatus || [];
  const InvestorLetterfrequency = Gstate.investorFrequency.investorFrequency || [];
  const PerformanceEstimatefrequency = Gstate.performanceEstimateFrequency.performanceEstimateFrequency || [];
  const Reportingfrequency = Gstate.reportingFrequency.reportingFrequency || [];
  const ExposureReportingfrequency = Gstate.exposureReportingFrequency.exposureReportingFrequency || [];
  const InvestinOtherFunds = Gstate.investInOtherFunds.investInOtherFunds || [];
  const InvestmentType = Gstate.investmentType.investmentType || [];

  const [attributes, setAttributes] = useState(Attributes);
  const [attributeLoading,setAttributeLoading]=useState(true);

  const [country, setCountry] = useState([]);
  const [issuerData, setIssuerData] = useState([]);
  const [feeFrequencyData, setFeeFrequencyData] = useState([]);


  const HF=[1 ,11 ,12];
  const PE=[2 ,5 ,13, 18 ,19 ,20];
  const AssetType = currentAsset?.SecurityTypeId || 0;

  useEffect(() => {
    dispatch(getAsset(params.Asset));
    dispatch(getAssetAttributes(params.Asset));
    dispatch(getAssetchart());
    dispatch(getAttributescurrency());
    dispatch(getAttributelegalStructure());
    dispatch(getSecurityType());
    dispatch(getAssetFilingStatus());
    dispatch(getInvestorFrequency());
    dispatch(getAssetReportingFrequency());
    dispatch(getExposuresReportingFrequency());
    dispatch(getEstimateFrequency());
    dispatch(getInvestInOtherFunds());
    dispatch(getAssetInvestmentType());
    dispatch(getAssestListddlAction());
    setCountriesFromAPI();
    setIssuerFromAPI();
    setFeeFrequencyFromAPI();
  }, []);

  useEffect(() => {
    setAttributes(Attributes);
    setAttributeLoading(isLoading)
  }, [Attributes]);

  const Level = [
    { BreadCrumb: "Asset >", Routes: `${UrlPath.Asset}` },
    { BreadCrumb: `${currentAsset.AssetName} >`, Routes: `${UrlPath.AssetDetails}${params.Asset}` },
    { BreadCrumb: "Edit", Routes: `${UrlPath.AssetEdit}${params.Asset}` },
  ];

  const setCountriesFromAPI = () => {
    sbaAxios({ url: getCountries }).then((res) => {
      setCountry(res);
    }).catch(error => {
      console.log(error, "error fetching data For Countries");
    })
  };
  const setIssuerFromAPI = () => {
    sbaAxios({ url: `${getEnumerations}${"Issuer"}` }).then((res) => {
      setIssuerData(res);
    }).catch(error => {
      console.log(error, "error fetching data For Countries");
    })
  };
  const setFeeFrequencyFromAPI = () => {
    sbaAxios({ url: `${getEnumerations}${"FeeFrequency"}` }).then((res) => {
      setFeeFrequencyData(res);
    }).catch(error => {
      console.log(error, "error fetching data For Countries");
    })
  };

  const CancelEdit = () => {
    history(`${UrlPath.AssetDetails}${params.Asset}`, { state: { ActiveTab: "Attributes", ActiveTabID: 2 } })
  };
  const UpdateAttributeDetails = (event) => {
    event.preventDefault();
    let saveSuccess = true;
    const data = {
      "assetId": attributes?.AssetId || 0,
      "assetAttributeId": attributes?.AssetAttributeId || 0,
      "assetAttributeHFId": attributes?.AssetAttributeHFId || 0,
      "assetAttributePEId": attributes?.AssetAttributePEId || 0,
      "assetAttributeMSId": attributes?.AssetAttributeMSId || 0,
      "assetFamilyId": attributes?.AssetFamilyId || null,
      "assetFamily": attributes?.AssetFamily ||  "",
      "chartOfAccountId": attributes?.ChartOfAccountId || null,
      "chartOfAccount": attributes?.ChartOfAccount || "",
      "operatingCurrencyId": attributes?.OperatingCurrencyId || null,
      "operatingCurrency": attributes?.OperatingCurrency ||  "",
      "legalStructureId": attributes?.LegalStructureId || null,
      "legalStructure": attributes?.LegalStructure|| "",
      "domicileCountryId": attributes?.DomicileCountryId ||  null,
      "domicileCountry": attributes?.DomicileCountry||  "",
      "quarterlyLetter": attributes?.QuarterlyLetter || null,
      "assetSecurityTypeId": attributes?.AssetSecurityTypeId ||  null,
      "assetSecurityType": attributes?.AssetSecurityType || "",
      "auditCompletionDate": attributes?.AuditCompletionDate ||  "",
      "investmentTypeId": attributes?.InvestmentTypeId || null,
      "investmentType": attributes?.InvestmentType ||  "",
      "investmentPack": attributes?.InvestmentPack || null,
      "assetFactSheet": attributes?.AssetFactSheet ||  null,
      "allowsSidePocket": attributes?.AllowsSidePocket || false,
      "investsInOtherFundsId": attributes?.InvestsInOtherFundsId || 0,
      "investsInOtherFunds":attributes?.InvestsInOtherFunds ||  "",
      "exposureReportFrequencyId": attributes?.ExposureReportFrequencyId ||  null,
      "exposureReportFrequency":attributes?.ExposureReportingfrequency || "",
      "personalCapital": attributes?.PersonalCapital || null,
      "accceptsManagedAccounts": attributes?.AccceptsManagedAccounts || false,
      "investsInManagedAccount": attributes?.InvestsInManagedAccount || false,
      "tradingCity": attributes?.TradingCity || null,
      "prohibitsUSInvestors": attributes?.ProhibitsUSInvestors || null,
      "filingStatusId": attributes?.FilingStatusId ||  0,
      "filingStatus": attributes?.FilingStatus ||  "",
      "keyMan": attributes?.KeyMan || null,
      "investorLetterFrequencyId": attributes?.InvestorLetterFrequencyId || null,
      "investorLetterFrequency":attributes?.InvestorLetterFrequency || "",
      "perfEstimateFrequencyId": attributes?.PerfEstimateFrequencyId ||  null,
      "perfEstimateFrequency": attributes?.PerfEstimateFrequency || "",
      "bloombergId": attributes?.BloombergId || null,
      "reportingFrequencyId": attributes?.ReportingFrequencyId || 0,
      "reportingFrequency": attributes?.ReportingFrequency || "",
      "fiscalYear": attributes?.FiscalYear || null,
      "taxId": attributes?.TaxId || "",
      "cimaId":attributes?.CIMAId || "",
      "formDNumber": attributes?.FormDNumber || "",
      "vintageYear": attributes?.VintageYear ||(new Date()).toISOString(),
      "targetFundRaise": attributes?.TargetFundRaise || 0,
      "estimatedFirstCloseDate": attributes?.EstimatedFirstCloseDate ||(new Date()).toISOString(),
      "estimatedFirstCloseAmount": attributes?.EstimatedFirstCloseAmount || 0,
      "estimatedSecondCloseDate": attributes?.EstimatedSecondCloseDate ||(new Date()).toISOString(),
      "estimatedSecondCloseAmount":  attributes?.EstimatedSecondCloseAmount || 0,
      "offerCoInvestment": attributes?.OfferCoInvestment ||  false,
      "singleDealFund":attributes?.SingleDealFund ||  false,
      "continuationFund": attributes?.ContinuationFund || false,
      "issuerId": attributes?.IssuerId || 0,
      "issuer": attributes?.Issuer || "",
      "sharesOutstanding": attributes?.SharesOutstanding ||  0,
      "cusip": attributes?.CUSIP || "",
      "isin": attributes?.ISIN  || "",
      "managementFee": attributes?.ManagementFee ||  0,
      "fundFeeExpenses": attributes?.FundFeeExpenses ||  0,
      "otherExpenses":attributes?.OtherExpenses || 0,
      "expenseRatio": attributes?.ExpenseRatio || 0,
      "distributionFrequencyId": attributes?.DistributionFrequencyId || 0,
      "distributionFrequency": attributes?.DistributionFrequency ||  "",
      "isMarketable": attributes?.IsMarketable || false,
      "modifiedBy": 0,
      "isClientSpecific":attributes?.IsClientSpecific || false
    };
    if (saveSuccess) {
      sbaAxios({
        url: `${InsertorUpdateAttributes}`,
        method: 'post',
        data: data,
      }).then((responseData) => {
        if(attributes.IsMarketable)
        {
          sbaAxios({
            url: `${InsertorUpdateMSAttributes}`,
            method: 'post',
            data: data,
          }).then((responseData) => {
            SBNotify({Msg:"Attribute Updated Successfully"}); 
            setTimeout(() => {
            history(`${UrlPath.AssetDetails}${params.Asset}`, { state: { ActiveTab: "Attributes", ActiveTabID: 2 } });  
            }, 1000);
          }).catch((error) => {
              console.error(error);
            });
        }
        else if(HF.includes(AssetType))
        {
          sbaAxios({
            url: `${InsertorUpdateHFAttributes}`,
            method: 'post',
            data: data,
          }).then((responseData) => {
            SBNotify({Msg:"Attribute Updated Successfully"}); 
            setTimeout(() => {
              (history(`${UrlPath.AssetDetails}${params.Asset}`, { state: { ActiveTab: "Attributes", ActiveTabID: 2 } }));              
            }, 1000);
          }).catch((error) => {
              console.error(error);
            });
        }
        else if(PE.includes(AssetType))
        {
          sbaAxios({
            url: `${InsertorUpdatePEAttributes}`,
            method: 'post',
            data: data,
          }).then((responseData) => {
            SBNotify({Msg:"Attribute Updated Successfully"});
            setTimeout(() => {
              (history(`${UrlPath.AssetDetails}${params.Asset}`, { state: { ActiveTab: "Attributes", ActiveTabID: 2 } }));
            }, 1000);
          }).catch((error) => {
              console.error(error);
            });
        }
       
      }).catch((error) => {
        console.log(error);
      });
     
    }

  };
  return <>
    {attributeLoading ? <><LoadingScreen /></> : <>
      <TopBar label={"Attributes Edit"} />
      <div className="mainContentData">
        <BreadCrumbs Levels={Level} />
        {attributes.IsMarketable  && <MSLayoutEditor Attrributes={attributes} setAttributes={setAttributes}  country={country} issuerData={issuerData} feeFrequencyData={feeFrequencyData} />}
        {PE.includes(AssetType)  && <PELayoutEditor Attrributes={attributes} setAttributes={setAttributes} country={country}  />}
        {HF.includes(AssetType) && <HFLayoutEditor Attrributes={attributes} setAttributes={setAttributes} country={country}/> } 
        <div className="d-flex  justify-content-end p-0 my-3">
          <button className="s-sm-btn mx-1" onClick={CancelEdit}> Cancel</button>
          <button className='p-sm-btn mx-1' onClick={UpdateAttributeDetails} disabled={!isEditable}>Update</button>
        </div>
      </div>
      <ToastContainer/>
    </>}
  </>
};


const PELayoutEditor = ({ Attrributes , setAttributes,country}) => {
  const Gstate = useSelector((state) => state) || {};

  const LegalStructureDS = Gstate.attributelegalstructure.attributelegalstructure || [];
  const AttributesCurrencyDs = Gstate.attributescurrency.attributescurrency || [];

  
  const updateState=(value,Field)=>{
    setAttributes(attribute=>({...attribute,[Field]:value}))
  };
  const updateDDState=(value,valueField,name,nameField)=>{
    setAttributes(attribute=>({...attribute,[valueField]:value,[nameField]:name}))
  };
  const LegalSt={
    EnumName:Attrributes?.LegalStructure,
    EnumValue:Attrributes?.LegalStructureId
  };
  const OperatingCur={
    CurrencyId:Attrributes?.OperatingCurrencyId,
    CurrencyName:Attrributes?.OperatingCurrency
  };
  const domicileCountry = {
    "CountryId": Attrributes.DomicileCountryId,
    "CountryName": Attrributes.DomicileCountry,
  };
  return <>
    <div className="detail p-2">
      <div className="row m-0">
        <div className="col-sm-8 p-2 detail">
            <div class="row m-0">
              <p>Legal</p>
            </div>
            <div class="row  mb-3 ">
                   <DatePickerEditor Value={Attrributes?.VintageYear} Label={"Vintage Year"} ColLength={"col-sm-4"} setValue={(e)=>{updateState(e.toISOString(),"VintageYear")}}/>
                   <TextBoxEditor Value={Attrributes?.TradingCity} Label={"Trading City"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.value, "TradingCity") }} />
                   <TextBoxEditor Value={Attrributes?.TargetFundRaise} Label={"Target Fund Raise"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.value, "TargetFundRaise") }} />
            </div>
            <div class="row  mb-3 ">
                  <TextBoxEditor Value={Attrributes?.BloombergId} Label={"Ticker"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.value, "BloombergId") }} />
                  <DatePickerEditor Value={Attrributes?.AuditCompletionDate} Label={"Audit  Completion Date"} ColLength={"col-sm-4"} type={"Date"} setValue={(e) => { updateState(e.toISOString(), "AuditCompletionDate") }} />
                  <DatePickerEditor Value={Attrributes?.FiscalYear} Label={"Fiscal Year End Date"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.toISOString(), "FiscalYear") }} />
             </div>
            <div class="row mb-3">
                 <DropDownEditor Value={LegalSt} Label={"Legal Structure"} ColLength={"col-sm-4"} data={LegalStructureDS} textField={"EnumName"} valueField={"EnumValue"} setValue={(e)=>{if(e.value){updateDDState(e.value.EnumValue,"LegalStructureId",e.value.EnumName,"LegalStructure")}}} />
                 <DatePickerEditor Value={Attrributes?.EstimatedFirstCloseDate} Label={"Estimated First Close Date"} ColLength={"col-sm-4"} type={"Date"} setValue={(e)=>{updateState(e.toISOString(),"EstimatedFirstCloseDate")}} />
                 <CheckBoxEditor Value={Attrributes?.SingleDealFund} Label={"Single Deal Fund"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.checked, "SingleDealFund") }} />
             </div>
            <div class="row mb-3">
                   <DropDownEditor Value={OperatingCur} Label={"Operation Currency"} ColLength={"col-sm-4"}  data={AttributesCurrencyDs} textField={"CurrencyName"} valueField={"CurrencyId"} setValue={(e)=>{if(e.value){updateDDState(e.value.CurrencyId,"OperatingCurrencyId",e.value.CurrencyName,"OperatingCurrency")}}} />
                   <TextBoxEditor Value={Attrributes?.EstimatedFirstCloseAmount} Label={"Estimated First Close Amount"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.value, "EstimatedFirstCloseAmount") }} />
                   <CheckBoxEditor Value={Attrributes?.ContinuationFund} Label={"Continuation Fund"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.checked, "ContinuationFund") }} />
             </div>
            <div class="row mb-3">
                     <DropDownEditor Value={domicileCountry} Label={"Domicile Country"} ColLength={"col-sm-4"} data={country} textField={"CountryName"} valueField={"CountryId"} setValue={(e)=>{if(e.value){updateDDState(e.value.CountryId,"DomicileCountryId",e.value.CountryName,"DomicileCountry")}}}  />
                     <DatePickerEditor Value={Attrributes?.EstimatedSecondCloseDate} Label={"Estimated Second Close Date"} ColLength={"col-sm-4"} type={"Date"} setValue={(e)=>{updateState(e.toISOString(),"EstimatedSecondCloseDate")}} />
                     <CheckBoxEditor Value={Attrributes?.OfferCoInvestment} Label={"Offer Co-Investment"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.checked, "OfferCoInvestment") }} />

            </div>
            <div class="row mb-3">
                     <TextBoxEditor Value={Attrributes?.EstimatedSecondCloseAmount} Label={"Estimated Second Close Amount"} ColLength={"col-sm-4"} setValue={(e)=>{updateState(e.target.value,"EstimatedSecondCloseAmount")}} />
                     <CheckBoxEditor Value={Attrributes?.IsClientSpecific} Label={"Client Specific"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.checked, "IsClientSpecific") }} />
          
              </div>
        </div>
        <div className="col-sm-4 p-2 detail">
          <ReportingSection Attrributes={Attrributes} setAttributes={setAttributes}/>
        </div>
      </div>
    </div>
  </>
};
const HFLayoutEditor = ({ Attrributes, setAttributes ,country}) => {
  
  const Gstate = useSelector((state) => state) || {};
  const LegalStructureDS = Gstate.attributelegalstructure.attributelegalstructure || [];
  const AttributesCurrencyDs = Gstate.attributescurrency.attributescurrency || [];
  const FilingStatusDs = Gstate.filingStatus.filingStatus || [];
  const AssetListDDL = Gstate.assetDDL.assetList || [];
  const InvestinOtherFunds = Gstate.investInOtherFunds.investInOtherFunds || [];

  const updateState=(value,Field)=>{
    setAttributes(attribute=>({...attribute,[Field]:value}))
  };
  const updateDDState=(value,valueField,name,nameField)=>{
    setAttributes(attribute=>({...attribute,[valueField]:value,[nameField]:name}))
  };
  const LegalSt={
    EnumName:Attrributes?.LegalStructure,
    EnumValue:Attrributes?.LegalStructureId
  };
  const OperatingCur={
    CurrencyId:Attrributes?.OperatingCurrencyId,
    CurrencyName:Attrributes?.OperatingCurrency
  };
  const domicileCountry = {
    "CountryId": Attrributes.DomicileCountryId,
    "CountryName": Attrributes.DomicileCountry,
  };
  const filingStatus={
    EnumValue:Attrributes.FilingStatusId,
    EnumName:Attrributes.FilingStatus
  };
  const assetFamily={
    AssetName:Attrributes.AssetFamily,
    AssetId:Attrributes.AssetFamilyId
  };
  const investInOtherFund = {
    "EnumValue": Attrributes.InvestsInOtherFundsId,
    "EnumName": Attrributes.InvestsInOtherFunds,
  };

  return <>
    <div className="detail p-2">
      <div className="row m-0">
        <div className="col-sm-8 p-3 detail">
          <div class="row m-0">
            <p>Legal</p>
          </div>
          <div class="row mb-3">
                      <DropDownEditor Value={LegalSt} Label={"Legal Structure"} ColLength={"col-sm-4"} data={LegalStructureDS} textField={"EnumName"} valueField={"EnumValue"} setValue={(e)=>{if(e.value){updateDDState(e.value.EnumValue,"LegalStructureId",e.value.EnumName,"LegalStructure")}}}/>
                     {/* <DatePickerEditor Value={Attrributes?.inceptionDate} Label={"Inception Date"} ColLength={"col-sm-4"} setValue={(e)=>{updateState(e.toISOString(),"inceptionDate")}}/> */}
                      <TextBoxEditor Value={Attrributes?.TradingCity} Label={"Trading City"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.value, "TradingCity") }} />
                      <CheckBoxEditor Value={Attrributes?.ProhibitsUSInvestors} Label={"Prohibits US Investor"} ColLength={"col-sm-4"} setValue={(e)=>{updateState(e.target.checked,"ProhibitsUSInvestors")}} />
           </div>
          <div class="row mb-3">
                     <TextBoxEditor Value={Attrributes?.BloombergId} Label={"Ticker"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.value, "BloombergId") }} />
                      <DatePickerEditor Value={Attrributes?.AuditCompletionDate} Label={"Audit Completion Date"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.toISOString(), "AuditCompletionDate") }} />
                      <CheckBoxEditor Value={Attrributes?.AccceptsManagedAccounts} Label={"Accepts Managed Accounts"} ColLength={"col-sm-4"} setValue={(e => { updateState(e.target.checked, "AccceptsManagedAccounts") })} />
           </div>
          <div className="row mb-3">
                      <DropDownEditor Value={OperatingCur} Label={"Operation Currency"} ColLength={"col-sm-4"}  data={AttributesCurrencyDs} textField={"CurrencyName"} valueField={"CurrencyId"} setValue={(e)=>{if(e.value){updateDDState(e.value.CurrencyId,"OperatingCurrencyId",e.value.CurrencyName,"OperatingCurrency")}}} />
                      <TextBoxEditor Value={Attrributes?.FormDNumber} Label={"FromD Number"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.value, "FormDNumber") }} type={"number"} />
                      <CheckBoxEditor Value={Attrributes?.AllowsSidePocket} Label={"Allow Side Pocket"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.checked, "AllowsSidePocket") }} />
          </div>
          <div class="row mb-3">
                      <DatePickerEditor Value={Attrributes?.FiscalYear} Label={"Fiscal Year End Date"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.toISOString(), "FiscalYear") }} />
                      <DropDownEditor Value={filingStatus} Label={"Filing Status"} ColLength={"col-sm-4"} data={FilingStatusDs} textField={"EnumName"} valueField={"EnumValue"} setValue={(e) => { if (e.value) { updateDDState(e.value.EnumValue, "FilingStatusId", e.value.EnumName, "FilingStatus") } }} />
                      <CheckBoxEditor Value={Attrributes?.InvestsInManagedAccount} Label={"Invests in Managed Accounts"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.checked, "InvestsInManagedAccount") }} />
          </div>
                 
        <div class="row mb-3">
         <DropDownEditor Value={domicileCountry} Label={"Domicile Country"} ColLength={"col-sm-4"} data={country} textField={"CountryName"} valueField={"CountryId"} setValue={(e) => { if (e.value) { updateDDState(e.value.CountryId, "DomicileCountryId", e.value.CountryName, "DomicileCountry") } }} />
            <DropDownEditor Value={investInOtherFund} data={InvestinOtherFunds} Label={"Invests in Other Funds"} ColLength={"col-sm-4"}  textField={"EnumName"} valueField={"EnumValue"} setValue={(e)=>{if(e.value){updateDDState(e.value.EnumValue,"InvestsInOtherFundsId",e.value.EnumName,"InvestsInOtherFunds")}}}  />
            <CheckBoxEditor Value={Attrributes?.KeyMan} Label={"Key Man"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.checked, "KeyMan") }} />
          </div>
          <div class="row mb-3">
                      <DropDownEditor Value={assetFamily} Label={"Asset Family"} ColLength={"col-sm-4"} data={AssetListDDL} textField={"AssetName"} valueField={"AssetId"} setValue={(e) => { if (e.value) { updateDDState(e.value.AssetId, "AssetFamilyId", e.value.AssetName, "AssetFamily") } }} />
                      <CheckBoxEditor Value={Attrributes?.IsClientSpecific} Label={"Client Specific"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.checked, "IsClientSpecific") }} />

          </div>
        </div>
        <div className="col-sm-4 p-2 detail">
          <ReportingSection Attrributes={Attrributes} setAttributes={setAttributes} />
        </div>
      </div>
    </div>
  </>
};
const MSLayoutEditor = ({ Attrributes,setAttributes ,country ,issuerData,feeFrequencyData}) => {
  const Gstate = useSelector((state) => state) || {};
  const LegalStructureDS = Gstate.attributelegalstructure.attributelegalstructure || [];
  const Reportingfrequency = Gstate.reportingFrequency.reportingFrequency || [];
  const AttributesCurrencyDs = Gstate.attributescurrency.attributescurrency || [];


  const updateState = (value, Field) => {
    setAttributes(attribute => ({ ...attribute, [Field]: value }))
  };
  const updateDDState = (value, valueField, name, nameField) => {
    setAttributes(attribute => ({ ...attribute, [valueField]: value, [nameField]: name }))
  };
  const issuer={
    EnumValue:Attrributes.IssuerId,
    EnumName:Attrributes.Issuer
  };
  const ReportingFre={
    EnumValue:Attrributes.ReportingFrequencyId,
    EnumName:Attrributes.ReportingFrequency
  };
  const domicileCountry = {
    "CountryId": Attrributes.DomicileCountryId,
    "CountryName": Attrributes.DomicileCountry,
  };
  const LegalSt = {
    EnumName: Attrributes?.LegalStructure,
    EnumValue: Attrributes?.LegalStructureId
  };
  const OperatingCur={
    CurrencyId:Attrributes?.OperatingCurrencyId,
    CurrencyName:Attrributes?.OperatingCurrency
  };
  const disFre = {
    EnumName: Attrributes?.DistributionFrequency,
    EnumValue: Attrributes?.DistributionFrequencyId
  };
  return <>
    <div className="detail p-1 row m-0">
      <div className="col-sm-8">
        <div class="row detail m-0  p-3">
          <div class="row ">
            <p>Legal</p>
          </div>
          <div class="row mb-3">
            <DropDownEditor Value={issuer} Label={"Issuer"} ColLength={"col-sm-4"}  data={issuerData} textField={"EnumName"} valueField={"EnumValue"} setValue={(e)=>{if(e.value){updateDDState(e.value.EnumValue,"IssuerId",e.value.EnumName,"Issuer")}}}/>
             <TextBoxEditor Value={Attrributes?.TradingCity} Label={"Trading City"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.value, "TradingCity") }} />
            <TextBoxEditor Value={Attrributes?.ManagementFee} Label={"Management Fee"} ColLength={"col-sm-4"}  setValue={(e)=>{updateState(e.target.value,"ManagementFee")}}/>
           </div>
           <div class="row mb-3">
             <TextBoxEditor Value={Attrributes?.BloombergId} Label={"Ticker"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.value, "BloombergId") }} />
             <DatePickerEditor Value={Attrributes?.AuditCompletionDate} Label={"Audit Completion Date"} ColLength={"col-sm-4"} type={"Date"} setValue={(e) => { updateState(e.toISOString(), "AuditCompletionDate") }} />
             <TextBoxEditor Value={Attrributes?.FundFeeExpenses} Label={"Fund Fees and Expenses"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.value, "FundFeeExpenses") }} />
            </div>
          <div class="row mb-3">
            <DatePickerEditor Value={Attrributes?.FiscalYear} Label={"Fiscal Year End"} ColLength={"col-sm-4"} type={"Date"} setValue={(e)=>{updateState(e.toISOString(),"FiscalYear")}}/>
            <DropDownEditor Value={ReportingFre} Label={"Reporting Frequency"} ColLength={"col-sm-4"} data={Reportingfrequency} textField={"EnumName"} valueField={"EnumValue"} setValue={(e)=>{if(e.value){updateDDState(e.value.EnumValue,"ReportingFrequencyId",e.value.EnumName,"ReportingFrequency")}}} />
           <TextBoxEditor Value={Attrributes?.OtherExpenses} Label={"Other Expenses"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.value, "OtherExpenses") }} />
          </div>
          <div class="row mb-3">
            <DropDownEditor Value={LegalSt} Label={"Legal Structure"} ColLength={"col-sm-4"} data={LegalStructureDS} textField={"EnumName"} valueField={"EnumValue"} setValue={(e)=>{if(e.value){updateDDState(e.value.EnumValue,"LegalStructureId",e.value.EnumName,"LegalStructure")}}} />
            <TextBoxEditor Value={Attrributes?.CUSIP} Label={"CUSIP"} ColLength={"col-sm-4"} setValue={(e)=>{updateState(e.target.value,"CUSIP")}} />
            <TextBoxEditor Value={Attrributes?.ExpenseRatio} Label={"Expense Ratio"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.value, "ExpenseRatio") }} />
           </div>
          <div class="row mb-3">
            <DropDownEditor Value={OperatingCur} Label={"Operating Currency"} ColLength={"col-sm-4"} data={AttributesCurrencyDs} textField={"CurrencyName"} valueField={"CurrencyId"} setValue={(e)=>{if(e.value){updateDDState(e.value.CurrencyId,"OperatingCurrencyId",e.value.CurrencyName,"OperatingCurrency")}}} />
            <TextBoxEditor Value={Attrributes?.ISIN} Label={"ISIN"} ColLength={"col-sm-4"} setValue={(e)=>{updateState(e.target.value,"ISIN")}}/>
             <DropDownEditor Value={disFre} Label={"Distribution Frequency"} data={feeFrequencyData} textField={"EnumName"} valueField={"EnumValue"} ColLength={"col-sm-4"} setValue={(e) => { if (e.value) { updateDDState(e.value.EnumValue, "DistributionFrequencyId", e.value.EnumName, "DistributionFrequency") } }} />
          </div>
          <div class="row mb-3">
            <DropDownEditor Value={domicileCountry} Label={"Domicile Country"} ColLength={"col-sm-4"} data={country} textField={"CountryName"} valueField={"CountryId"} setValue={(e)=>{if(e.value){updateDDState(e.value.CountryId,"DomicileCountryId",e.value.CountryName,"DomicileCountry")}}}  />
            <TextBoxEditor Value={Attrributes?.SharesOutstanding} Label={"Shares Outstanding"} ColLength={"col-sm-4"} setValue={(e)=>{updateState(e.target.value,"SharesOutstanding")}} />
            <CheckBoxEditor Value={Attrributes?.IsClientSpecific} Label={"Client Specific"} ColLength={"col-sm-4"} setValue={(e) => { updateState(e.target.checked, "IsClientSpecific") }} />
          </div>        
        </div>
      </div>
    </div>
  </>
};
const ReportingSection = ({ Attrributes, setAttributes }) => {

  const Gstate = useSelector((state) => state) || {};
  const InvestorLetterfrequency = Gstate.investorFrequency.investorFrequency || [];
  const SecurityType = Gstate.securityType.securityType || [];
  const Reportingfrequency = Gstate.reportingFrequency.reportingFrequency || [];
  const PerformanceEstimatefrequency = Gstate.performanceEstimateFrequency.performanceEstimateFrequency || [];
  const InvestmentType = Gstate.investmentType.investmentType || [];
  const ExposureReportingfrequency = Gstate.exposureReportingFrequency.exposureReportingFrequency || [];


  const updateState=(value,Field)=>{
    setAttributes(attribute=>({...attribute,[Field]:value}))
  };
  const updateDDState=(value,valueField,name,nameField)=>{
    setAttributes(attribute=>({...attribute,[valueField]:value,[nameField]:name}))
  };

  const letterToInvestor={
    EnumName:Attrributes.InvestorLetterFrequency,
    EnumValue:Attrributes.InvestorLetterFrequencyId
  };
  const assetType={
    EnumName:Attrributes.AssetSecurityType,
    EnumValue:Attrributes.AssetSecurityTypeId
  };
  const reportingFre={
    EnumName:Attrributes.ReportingFrequency,
    EnumValue:Attrributes.ReportingFrequencyId
  };
  const performanceEstFre={
    EnumName:Attrributes.PerfEstimateFrequency,
    EnumValue:Attrributes.PerfEstimateFrequencyId
  };
  const investType={
    EnumName:Attrributes.InvestmentType,
    EnumValue:Attrributes.InvestmentTypeId
  };
  const exposureFre={
    EnumName:Attrributes.ExposureReportFrequency,
    EnumValue:Attrributes.ExposureReportFrequencyId
  };
  return <>
    <div class=" m-0  p-3">
      <div class="row ">
        <p>Reporting</p>
      </div>
      <div class="row mb-3">
        <DropDownEditor Value={letterToInvestor} Label={"Letter to Investor Frequency"} data={InvestorLetterfrequency} ColLength={"col-sm-6"} textField={"EnumName"} valueField={"EnumValue"} setValue={(e)=>{if(e.value){updateDDState(e.value.EnumValue,"InvestorLetterFrequencyId",e.value.EnumName,"InvestorLetterFrequency")}}}  />
        <DropDownEditor Value={assetType} Label={"Asset Type "} ColLength={"col-sm-6"} data={SecurityType} textField={"EnumName"} valueField={"EnumValue"} setValue={(e)=>{if(e.value){updateDDState(e.value.EnumValue,"AssetSecurityTypeId",e.value.EnumName,"AssetSecurityType")}}} />
      </div>
      <div class="row mb-3">
        <CheckBoxEditor Value={Attrributes?.QuarterlyLetter} Label={"Quarterly Letter"} ColLength={"col-sm-6"}  setValue={(e)=>{updateState(e.target.checked,"QuarterlyLetter")}}/>
        <CheckBoxEditor Value={Attrributes?.AssetFactSheet} Label={"Fact Sheet"} ColLength={"col-sm-6"}  setValue={(e)=>{updateState(e.target.checked,"AssetFactSheet")}}/>
      </div>
      <div class="row mb-3">
        <DropDownEditor Value={reportingFre} Label={"Reporting Frequency "} ColLength={"col-sm-6"} data={Reportingfrequency}  textField={"EnumName"} valueField={"EnumValue"} setValue={(e)=>{if(e.value){updateDDState(e.value.EnumValue,"ReportingFrequencyId",e.value.EnumName,"ReportingFrequency")}}}  />
        <CheckBoxEditor Value={Attrributes?.InvestmentPack} Label={"Investment Pack"} ColLength={"col-sm-6"} setValue={(e)=>{updateState(e.target.checked,"InvestmentPack")}} />
      </div>
      <div class="row mb-3">
        <DropDownEditor Value={performanceEstFre} Label={"Performance Estimate Frequency"} ColLength={"col-sm-6"}   textField={"EnumName"}  valueField={"EnumValue"} data={PerformanceEstimatefrequency} setValue={(e)=>{if(e.value){updateDDState(e.value.EnumValue,"PerfEstimateFrequencyId",e.value.EnumName,"PerfEstimateFrequency")}}} />
        <DropDownEditor Value={investType} Label={"Investment Type"} ColLength={"col-sm-6"}  textField={"EnumName"} valueField={"EnumValue"} data={InvestmentType} setValue={(e)=>{if(e.value){updateDDState(e.value.EnumValue,"InvestmentTypeId",e.value.EnumName,"InvestmentType")}}}  />
      </div>
      <div class="row mb-3">
        <DropDownEditor Value={exposureFre} Label={"Exposure Report Frequecy"} ColLength={"col-sm-6"} data={ExposureReportingfrequency} textField={"EnumName"} valueField={"EnumValue"} setValue={(e)=>{if(e.value){updateDDState(e.value.EnumValue,"ExposureReportFrequencyId",e.value.EnumName,"ExposureReportFrequency")}}}  />
        <TextBoxEditor Value={Attrributes?.PersonalCapital} Label={"Personal Captial"} ColLength={"col-sm-6"}  setValue={(e)=>{updateState(e.target.value,"PersonalCapital")}} type={"number"}/>
      </div>
    </div>
  </>
};
const DropDownEditor = ({ Value, Label, ColLength, data, setValue ,...props }) => {
  return <div className={ColLength}>
    <label className="d-block">{Label}</label>
    <SBADropDown
      value={Value}
      textField={"CountryName"}
      valueField={"CountryId"}
      data={data}
      onChange={(e) => { setValue(e) }}
      className="w-75"
      {...props}
    ></SBADropDown>
  </div>
};
const TextBoxEditor = ({ Value, Label, ColLength, setValue ,type }) => {
  return <>
    <div className={ColLength}>
      <label>{Label}</label>
      <input Value={Value}
        className="form-control w-75"
        type={type}
        onChange={(e) => { setValue(e) }}
      />
    </div>
  </>
};
const CheckBoxEditor = ({ Value, Label, ColLength, setValue }) => {
  return <div className={ColLength}>
    <label style={{ display: 'flex', alignItems: 'center' }}>
      <input className="me-1"
        type="checkbox"
        defaultChecked={Value}
        onChange={(e) => { setValue(e) }}
      />
      <span >{Label}</span>
    </label>
  </div>
};
const DatePickerEditor = ({ Value, Label, ColLength, setValue }) => {
  return <div className={ColLength}>
    <label className="d-block">{Label}</label>
    <SBDatePicker
      value={moment(Value)}
      onChange={(e) => {
        setValue(e)
      }}
    />
  </div>
};
